import { AbTestsData } from '~/server/services/shopConfigLoader/shopConfigLoader.types'
import { Cookies } from '~/module/shopConfig/shopConfigPlugin'

interface CalcAbTestsQuery {
  cookies: Cookies
  abTestsData: AbTestsData
}

export interface CalcAbTestsResult {
  menuAbTest: string | null
  campaignAbTests: Map<string, string>
  xsellAbTest: boolean
}

const getAbTestNumber = (test: string) => test.replace('_mgExp-', '')

const calcMenuAbTest = (query: CalcAbTestsQuery): string | null => {
  const menuAbTest = query.abTestsData?.menuAbTests?.find(
    (item) => query.cookies.abTests?.tests[item.key] !== undefined
  )
  if (menuAbTest) {
    const cookie = query.cookies.abTests?.tests[menuAbTest?.key]
    return cookie === menuAbTest.value
      ? `${getAbTestNumber(
          menuAbTest.key
        )}-${menuAbTest.value.toLocaleLowerCase()}`
      : null
  }
  return null
}

const calcCampaignAbTest = (query: CalcAbTestsQuery): Map<string, string> => {
  return query.abTestsData.campaignAbTests.reduce((acc, val) => {
    const abTest = query.cookies.abTests?.tests[val.abTestId]
    return abTest ? acc.set(val.id, abTest) : acc
  }, new Map<string, string>())
}

const calcXSellAbTest = (query: CalcAbTestsQuery): boolean => {
  return query.cookies.abTests?.tests['_mgExp-53'] === 'b'
}

export const calcAbTests = (query: CalcAbTestsQuery): CalcAbTestsResult => {
  return {
    campaignAbTests: calcCampaignAbTest(query),
    menuAbTest: calcMenuAbTest(query),
    xsellAbTest: calcXSellAbTest(query),
  }
}
